import React from "react";
import Tools from "../../components/pages/tools/Tools";

export default function ToolsPage() {
  return <Tools />;
}
